/*
   Alan
   Customising react-select-me
   https://github.com/maslianok/react-select-me
*/
import "./select.scss";
import Select from "react-select-me";
import "react-select-me/lib/ReactSelectMe.css";
import { useState } from "react";
import { Loader } from "rsuite";
import ErrorTooltip from "components/ErrorTooltip/ErrorTooltip";

function OutlinedSelect({
  defaultValue = [],
  value = [],
  wrapperClass = "",
  selectControlClass = "",
  listClass = "",
  optionsClass = "",
  selectedOptionClass = "",
  type = "primary",
  rounded = false,
  size = "md",
  options,
  multiple = false,
  searchable = false,
  onChange,
  optionOutlined = false,
  label,
  searchIcon,
  error = null,
  loading = false,
  ...rest
}) {
  // overriding default styles
  const classNames = {
    dd__wrapper: ``,
    dd__selectControl: `selectOutlined__select_control`,
    dd__option: ``,
    dd__selectedOption: ``,
    dd__list: `selectOutlined__select_list`,
  };

  // function to render icon
  const renderIcon = (isOpen) => {
    if (loading) {
      return <Loader />;
    }
    if (!searchIcon && !loading) {
      return (
        <span className="material-icons">
          {isOpen ? "keyboard_arrow_up" : "keyboard_arrow_down"}
        </span>
      );
    }
    if (searchIcon) {
      return (
        <span className="material-icons font-md-2 cif__text_secondary">
          search
        </span>
      );
    }
  };

  return (
    <>
      {error && <ErrorTooltip text={error} />}
      <div className="selectOutlined__wrapper">
        <label className="selectOutlined__label">{label}</label>
        <Select
          s={classNames}
          value={value}
          onChange={onChange}
          options={options}
          iconRenderer={renderIcon}
          multiple={multiple}
          searchable={searchable}
          {...rest}
        />
      </div>
    </>
  );
}

export default OutlinedSelect;
